import { StateCreator } from "zustand";
import { ChatHistory } from "../../api/models";

export interface ChatHistorySlice {
  // 1. Update type to include null
  chatHistory: ChatHistory | null;
  setChatHistory: (
    chatHistory:
      | ChatHistory
      | null
      | ((prevState: ChatHistory | null) => ChatHistory | null),
  ) => void;
  chatHistoryPanel: boolean;
  setChatHistoryPanel: (
    chatHistoryPanel: boolean | ((prevState: boolean) => boolean),
  ) => void;
}

const createChatHistorySlice: StateCreator<
  ChatHistorySlice,
  [],
  [],
  ChatHistorySlice
> = (set) => ({
  // 2. Set default value to null
  chatHistory: null,
  setChatHistory: (chatHistory) =>
    set((state) => ({
      chatHistory:
        typeof chatHistory === "function"
          ? chatHistory(state.chatHistory)
          : chatHistory,
    })),
  chatHistoryPanel: false,
  setChatHistoryPanel: (chatHistoryPanel) =>
    set((state) => ({
      chatHistoryPanel:
        typeof chatHistoryPanel === "function"
          ? chatHistoryPanel(state.chatHistoryPanel)
          : chatHistoryPanel,
    })),
});

export default createChatHistorySlice;
